export function pad(number, width, character) {
  character = character || "0";
  number = number + "";
  return number.length >= width
    ? number
    : new Array(width - number.length + 1).join(character) + number;
}

export const uuid = (pre = "") =>
  pre.replace(/ /g, "-") +
  Math.random()
    .toString(36)
    .substr(2, 9);
